// vendors
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import { Stack, HeadingContainer, Heading } from '../Form/Form.styles';

import { Container } from './Wizard.styles';
import Navigation from './Navigation';

import { WizardContext } from './WizardContext';

const Wizard = ({ formTitle, onSubmit, children }) => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = React.Children.toArray(children);

  const initialValues = steps.reduce(
    (acc, cur) => ({ ...acc, ...cur.props.initialValues }),
    {}
  );

  const stepsTitle = steps.reduce((acc, cur) => {
    acc.push(cur.props.title);
    return acc;
  }, []);

  const step = steps[activeStep];
  const totalSteps = steps.length;
  const isLastStep = activeStep === totalSteps - 1;
  const isFirstStep = activeStep === 0;

  const handleSubmit = async (values, actions) => {
    const { setSubmitting } = actions;

    setSubmitting(true);

    if (isLastStep) {
      const response = await onSubmit(values, actions);

      setSubmitting(false);

      return response;
    }

    // Reset touched for all fields
    actions.setTouched({});
    setSubmitting(false);

    setActiveStep(activeStep + 1);

    window.scrollTo({ top: 0, behavior: `smooth` });

    return true;
  };

  const handleClickPrevious = () => {
    setActiveStep(activeStep - 1);
  };

  const handleClickStep = (stepIndex) => {
    setActiveStep(stepIndex);
  };

  return (
    <WizardContext.Provider
      value={{ activeStep, isFirstStep, isLastStep, totalSteps, stepsTitle }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={step.props.validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <Container>
              <Stack>
                <HeadingContainer>
                  <Heading>{formTitle}</Heading>
                </HeadingContainer>
                {step}
              </Stack>
            </Container>

            <Navigation
              onPreviousClick={handleClickPrevious}
              onStepClick={handleClickStep}
            />
          </form>
        )}
      </Formik>
    </WizardContext.Provider>
  );
};

Wizard.propTypes = {
  formTitle: PropTypes.node,
  onSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
};

Wizard.defaultProps = {
  formTitle: undefined,
  onSubmit: () => {},
};

export default Wizard;
